import { createClient } from '@supabase/supabase-js';
import type { Database } from '@/integrations/supabase/types';

const SUPABASE_URL = "https://hukmgamisjjgulkqacxm.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imh1a21nYW1pc2pqZ3Vsa3FhY3htIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjM0MzIwOTgsImV4cCI6MjA3OTAwODA5OH0.eK2fy-aqD93ld0mxf9j5q1cKcEpx1nU6t0GOg70EiDs";

const SESSION_KEY = "regard_de_nature_cart_session";

/**
 * Get or create the cart session ID
 */
export function getCartSessionId(): string {
  let session = localStorage.getItem(SESSION_KEY);
  if (!session) {
    // Ensure minimum 20 characters for RLS policy
    session = `session_${Date.now()}_${Math.random().toString(36).substr(2, 12)}`;
    localStorage.setItem(SESSION_KEY, session);
  }
  return session;
}

/**
 * Creates a Supabase client with the x-session-id header set for cart operations.
 * This is required because RLS policies on cart_items check this header.
 */
export function createCartClient(sessionId: string) {
  return createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
    auth: {
      storage: localStorage,
      persistSession: true,
      autoRefreshToken: true,
    },
    global: {
      headers: {
        'x-session-id': sessionId,
      },
    },
  });
}
